import React, {useState, useEffect} from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';

import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import ContentMarketingService from '../../services/contentMarketing.service';

import { fileTypes } from '../../constants/models/fileTypes';

import '../../styles/style.scss';
import '../../styles/contentScreenStyle.scss';
import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { SYSTEM } from '../../constants/models/typeOperationRol';

export const ContentMarketingScreen = (props) => {

  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-confirm-cancel-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

  const { user, isLoggedIn } = useSelector( state => state.auth);
  const operationRol = isLoggedIn? user.operationRol:'---';

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [content, setContent] = useState(['']);
  const [isLoadingData, setIsLoadingData] = useState(true);

  /** 
   * Ejecuta una vez servicio para recuperar lista de contenidos
   * -author alSanchez - ETE
   * -version 1.0.0 - Septiembre 2021
   * 
  */
  useEffect(() => {
    ContentMarketingService.getContents().then((response)=>{
      const dataArray= [];
      const sectionArray = [];

      response.forEach(data=>{

        if(sectionArray.filter(section => section === data.setion)){
          sectionArray.push(data.noSeccion);
        }
      });

      const uniqueSectionArray = [...new Set(sectionArray)];

      uniqueSectionArray.forEach(section=>{

        const fileArray = [];

        response.forEach(data=>{
          if(section === data.noSeccion){
            const fileType = data.document.split(',')[0].split(':')[1].split(';')[0];
            const fileProperties = fileTypes.find(dataFile => dataFile.type === fileType);
            fileArray.push({
              fileName: data.name,
              id: data.id,
              icon: fileProperties.icon,
              style: fileProperties.style,
              extension: fileProperties.extension,
              fileExtension: fileProperties.fileExtension,
              file: data.document
            }); 
          }
        });
        dataArray.push({
          section: section,
          files: fileArray
        });
      });
      setContent(dataArray);
      setIsLoadingData(false);

  }).catch((error)=>{
      setContent([]);
      setIsLoadingData(false);

      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error);
        }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  /**
   * Redireccionar a la pagina de crear contenido
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const getNewContent = () => {
    props.history.push('/administration/content/marketing/create');
    window.location.reload();
  }

  /**
   * Redireccionar a la pagina de crear contenido
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const getEditSection =() => {
    props.history.push('/administration/content/marketing/section');
    window.location.reload();
  }

  /**
   * Realiza la eliminación del archivo seleccionado
   * @param {string} fileName - nombre del archivo
   * @param {number} fileId - identificador del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const deleteFile = (fileName, fileId) => {
    console.log(fileName);
    swalCustomButtons.fire({
      title: 'Eliminar',
      html: `<span>Esta acción eliminará permanentemente el archivo </span> <span class="text-title-delete-file"> ${fileName}</span>`,
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        ContentMarketingService.deleteFile(fileId)
        .then((response)=>{
            console.log(response);
            Swal.fire({
              icon: 'success',
              title: 'Archivo eliminado exitosamente',
              showConfirmButton: true,
              confirmButtonText: 'Aceptar',
              });

              window.location.reload();
          })
          .catch((error) => {
            console.log(error);
            if(sessionDifference > Number(tokenExpired)){
              sesionExpired(dispatch, history);
            } else{
              actionErrorConnection(error, 'Error al borrar archivo.');
            }
          });
      }
    })
    
  };

  /**
   * Realiza la descarga del archivo
   * @param { string } fileName - nombre del archivo
   * @param { string } fileExtension - rxtensión del archivo
   * @param { string } file - data del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const downloadFile = (fileName, fileExtension,file) =>{
    const byteString = window.atob(file.split(',')[1]);
          const mimeString = file.split(',')[0].split(':')[1].split(';')[0];

          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }

          const dataBlob = new Blob([ab], { type: mimeString });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.${fileExtension}`);
            return
          }
    
          const url = window.URL.createObjectURL(dataBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${fileName}.${fileExtension}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
  };

  /**
   * Recupera el identificador del archivo y realiza la redirección a la pantalla de edición
   * @param {*} fileId - identificador del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const editFile = (fileId) => {
    props.history.push(`/administration/content/marketing/update/${fileId}`);
    window.location.reload();
  };

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                  <NavTopMenu />
                  <div className="container ps-3 pe-3 container-size">
                    <div className="row base-container ">
                      <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                        <span>Contenido </span>
                        <i className="fas fa-angle-right ms-2 me-2"></i>
                        <span>Avisos</span>
                      </div>
                      <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                        <div className="row ">
                          <div className="container p-0">
                            <div className="row m-0">
                              <div className="col-12">
                                { (validateAccessUser(view.CREATE_CONTENT, user) && operationRol === SYSTEM) &&
                                  <div className="w-100 d-flex justify-content-end">
                                    <Tooltip title="Editar secciones" placement="top-start" arrow>
                                      <button className="btn custom-btn-icons" 
                                      type="button" 
                                      onClick={getEditSection}
                                      >
                                        <i className="fas fa-pen-square custom-icon-add"></i>
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Nuevo contenido" placement="top-start" arrow>
                                      <button className="btn custom-btn-icons" 
                                      type="button" 
                                      onClick={getNewContent}
                                      >
                                        <i className="fas fa-plus-square custom-icon-add"></i>
                                      </button>
                                    </Tooltip>
                                  </div>
                                }
                              </div>    
                              <div className="col-12">
                                <div className="row">
                                  { !isLoadingData && (content && content.length > 0 ?
                                    content.map(({section, files}, i) => (
                                      <div className={`${files && files.length>3 ? 'col-md-12' : 'col-md-6'} mb-3`} key={i}>
                                        <div className="w-100 h-100 border-content-sections">
                                          <div className="row">
                                          <div className="col-md-9 pt-2">
                                            <div className="border-text-menu-title">
                                              <span className="text-title-section" >{section}</span>
                                            </div>
                                          </div>
                                          </div>
                                          <div className="row pb-2 pt-2 ps-1 pe-1">
                                            {files && files.map((fileData, j) => (
                                              <div className={`${files.length>3 ? 'col-md-6 ps-1 pe-1' : 'col-md-12'} `} key={j}>
                                                <div className="pt-1 pb-1 bg-file border-content-sections mb-2 ps-1">
                                                  <div className="row p-0 m-0">
                                                    <div className="col-1 p-0 m-0 d-flex align-items-center align-items-md-start align-items-lg-center">
                                                      <i className={`far ${fileData.icon} ${fileData.style} icon-list-size`}></i>
                                                    </div>
                                                    <div className="col-11 p-0 m-0">
                                                      <div className="row p-0 m-0">
                                                        <div className="col-8 col-md-12 col-lg-8 ps-md-2 ps-lg-1">
                                                          <span className="d-block text-title-document">{fileData.fileName}</span>
                                                          <span className="d-block text-sub-title-document">{fileData.extension}</span>
                                                        </div>
                                                        <div className="col-4 col-md-12 col-lg-4 hide-btn-action">
                                                          <div className="d-flex align-items-center h-100">
                                                            <div className="w-100 d-flex justify-content-center">
                                                              <Tooltip title="Descargar" placement="top-start" arrow>
                                                                <button className="btn-list custom-btn-icons" 
                                                                type="button"
                                                                onClick={() => downloadFile(fileData.fileName, fileData.fileExtension, fileData.file)}
                                                                >
                                                                  <i className="fas fa-cloud-download-alt"></i>
                                                                </button>
                                                              </Tooltip>
                                                              {(validateAccessUser(view.CREATE_CONTENT, user) && operationRol === SYSTEM) &&
                                                                <Tooltip title="Editar" placement="top-start" arrow>
                                                                  <button className="btn-list custom-btn-icons" 
                                                                  type="button" 
                                                                  onClick={() => editFile(fileData.id)}
                                                                  >
                                                                    <i className="fas fa-edit"></i>
                                                                  </button>
                                                                </Tooltip>
                                                              }
                                                              {(validateAccessUser(view.CREATE_CONTENT, user) && operationRol === SYSTEM) &&
                                                                <Tooltip title="Eliminar" placement="top-start" arrow>
                                                                  <button className="btn-list custom-btn-icons-danger" 
                                                                  type="button" 
                                                                  onClick={() => deleteFile(fileData.fileName,fileData.id)}
                                                                  >
                                                                    <i className="fas fa-trash"></i>
                                                                  </button>
                                                                </Tooltip>
                                                              }
                                                              
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  :
                                    <div className="col-md-12">
                                        <div className="w-100 element-row-message border-content-sections d-flex justify-content-center pt-5 pb-5">
                                        <span>Documentos no disponibles</span>
                                        </div>
                                    </div>
                                  )}
                                  { isLoadingData &&
                                    <div className="col-md-12">
                                      <div className="w-100 element-row-message custom-icon-loading border-content-sections d-flex justify-content-center pt-5 pb-5">
                                        <i className="fas fa-spinner fa-spin"></i>
                                      </div>
                                    </div>

                                  }
                                </div>
                              </div>                          
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <Footer/>
        </>
    )
}

ContentMarketingScreen.propTypes = {
  history: PropTypes.object
}
